export default (triggerOffset = 600) => ({
  isVisible: false,
  quantity: 1,
  isProcessing: false,
  selectedVariantId: null,
  isAvailable: true,
  productTitle: '',
  productImage: '',
  variants: [],

  init() {
    const productData = Alpine.store('productData')

    if (productData) {
      this.productTitle = productData.title || ''
      const currentVariant = productData.currentVariant
      this.selectedVariantId = currentVariant?.id || null
      this.isAvailable = currentVariant?.available || false
      this.productImage = currentVariant?.featured_image?.src || productData.featured_image || ''
      this.variants = productData.variants || []
    }

    this.setupScrollListener(triggerOffset)
    this.setupEventListeners()
  },

  setupScrollListener(offset) {
    const handleScroll = () => {
      requestAnimationFrame(() => {
        this.isVisible = window.scrollY > offset
      })
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    handleScroll()

    this.$el._cleanup = () => {
      window.removeEventListener('scroll', handleScroll)
    }
  },

  setupEventListeners() {
    document.addEventListener('variant:change', (event) => {
      const variant = event.detail.variant
      if (variant) {
        this.selectedVariantId = variant.id
        this.isAvailable = variant.available
        if (variant.featured_image?.src) {
          this.productImage = variant.featured_image.src
        }
      }
    })

    document.addEventListener('liquid-ajax-cart:request-start', () => {
      this.isProcessing = true
    })

    document.addEventListener('liquid-ajax-cart:request-end', () => {
      this.isProcessing = false
    })
  },

  handleVariantChange() {
    const variant = this.variants.find(v => v.id == this.selectedVariantId)
    if (variant) {
      this.isAvailable = variant.available
      if (variant.featured_image?.src) {
        this.productImage = variant.featured_image.src
      }

      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: { variant }
      }))
    }
  },

  incrementQuantity() {
    this.quantity++
  },

  decrementQuantity() {
    if (this.quantity > 1) {
      this.quantity--
    }
  },

  handleAddToCart(event) {
    if (!this.isAvailable) {
      event.preventDefault()
      return
    }
    this.isProcessing = true
  },

  destroy() {
    if (this.$el._cleanup) {
      this.$el._cleanup()
    }
  }
})
